import logo from './logo.svg';
import { Login } from './pages/Login';
import TimeEntry from './pages/TimeEntry';
import { isAuthenticated } from './AppSession';
import './App.css';

function App() {
  if (isAuthenticated()) {
    return (
      <div>
        <TimeEntry />
      </div>
    );
  } else {
    return (
      <div>
        <Login />
      </div>
    );
  }
}

export default App;
